import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimplesaudagartomumbaicabservice() {



  const cardData = {


    keyword: "Pimple Saudagar to Mumbai Cab Service",

  headingDescription: "Trustline Travels offers professional Pimple Saudagar to Mumbai cab services with safe, affordable, and comfortable transportation for corporate travel, airport transfers, business meetings, family vacations, and outstation journeys. Whether you need a one-way cab or a round-trip taxi, our experienced chauffeurs ensure on-time pickups and a smooth travel experience. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer support, Trustline Travels is your trusted partner for reliable Pimple Saudagar to Mumbai taxi services.",

  topPlaces: [
    {
      title: "Millennium Business Park",
      description: "Millennium Business Park in Mahape is one of Navi Mumbai's leading IT destinations, housing technology companies, software firms, and corporate offices."
    },
    {
      title: "Godrej IT Park",
      description: "Godrej IT Park is a modern commercial hub offering premium office spaces for multinational companies, startups, and technology businesses."
    },
    {
      title: "Goregaon Business District",
      description: "Goregaon is a growing commercial destination featuring corporate offices, IT companies, business parks, and exhibition venues."
    },
    {
      title: "MIDC Marol",
      description: "MIDC Marol is a well-established industrial and commercial zone with manufacturing units, logistics companies, and corporate offices."
    },
    {
      title: "TTC Industrial Area",
      description: "The TTC Industrial Area is one of Navi Mumbai's largest industrial corridors, home to engineering, logistics, pharmaceutical, and manufacturing companies."
    },
    {
      title: "Rabale MIDC",
      description: "Rabale MIDC is a prominent industrial and business hub accommodating leading technology companies, factories, and corporate establishments."
    },
    {
      title: "Gateway of India",
      description: "Gateway of India is Mumbai's iconic waterfront monument, admired for its historic architecture, sea views, and ferry access to Elephanta Island."
    },
    {
      title: "Hanging Gardens",
      description: "Hanging Gardens is a beautifully landscaped hilltop garden offering panoramic views of Marine Drive and the Arabian Sea."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is one of Mumbai's most popular shopping streets, known for fashion boutiques, handicrafts, cafés, and vibrant local markets."
    },
    {
      title: "Taraporewala Aquarium",
      description: "Taraporewala Aquarium is one of India's oldest aquariums, featuring a wide variety of marine life and interactive exhibits for visitors."
    }
  ],





"services": [
  {
    "name": "Pimple Saudagar to Mumbai Cab",
    "description": "Book Pimple Saudagar to Mumbai cab for comfortable intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles. Enjoy doorstep pickup, professional chauffeurs, transparent pricing, and reliable one-way, round-trip, airport, and corporate travel services available 24x7."
  },
  {
    "name": "Pimple Saudagar to Mumbai Airport Cab",
    "description": "Reserve Pimple Saudagar to Mumbai Airport cab with timely pickup, flight tracking, luggage assistance, and direct transfers to all domestic and international terminals. Ideal for business travelers, families, and corporate airport transfers."
  },
  {
    "name": "Pimple Saudagar to Mumbai International Airport",
    "description": "Book Pimple Saudagar to Mumbai International Airport cab for hassle-free travel to Chhatrapati Shivaji Maharaj International Airport. Premium AC vehicles, experienced drivers, and fixed fares ensure a smooth airport journey."
  },
  {
    "name": "Pimple Gurav to Mumbai Cab Service",
    "description": "Reliable Pimple Gurav to Mumbai cab service for one-way trips, airport transfers, business travel, sightseeing, and round-trip journeys with experienced chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Taxi Service in Pimple Gurav",
    "description": "Professional taxi service in Pimple Gurav for local travel, airport transfers, outstation journeys, corporate transportation, and intercity trips with comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Taxi Service in Pimple Saudagar Pune",
    "description": "Affordable taxi service in Pimple Saudagar Pune offering local cabs, airport transfers, outstation taxi services, and corporate transportation with transparent pricing and reliable drivers."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab with direct transfers to all airport terminals. Enjoy punctual pickup, flight monitoring, comfortable AC vehicles, and professional chauffeur service."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Choose Pune to Mumbai Ertiga cab for spacious family travel, airport transfers, business trips, and group journeys with affordable fares and experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab service provides luxury seating, extra luggage capacity, comfortable highway travel, and professional drivers for business and family travel."
  },
  {
    "name": "Top-rated Mumbai to Pimple Saudagar Cabs",
    "description": "Book top-rated Mumbai to Pimple Saudagar cabs with reliable pickup, clean vehicles, experienced chauffeurs, and transparent pricing for airport, corporate, and family travel."
  },
  {
    "name": "Pimple Saudagar to Dadar Cab Service",
    "description": "Reliable Pimple Saudagar to Dadar cab service for railway station transfers, business meetings, and family travel with fixed pricing and comfortable AC vehicles."
  },
  {
    "name": "Pimple Gurav to Dadar Cab Service",
    "description": "Reserve Pimple Gurav to Dadar cab service with experienced drivers, timely pickup, transparent fares, and comfortable vehicles for smooth intercity transportation."
  },
  {
    "name": "Cab Service in Pimple Gurav",
    "description": "Professional cab service in Pimple Gurav offering local, airport, outstation, and corporate transportation with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles."
  },
  {
    "name": "Innova Crysta on Rent in Pimple Saudagar Pune",
    "description": "Hire Innova Crysta on rent in Pimple Saudagar Pune for Mumbai travel, airport transfers, family vacations, business meetings, and premium outstation journeys."
  },
  {
    "name": "Pimple Saudagar to Andheri Cab",
    "description": "Book Pimple Saudagar to Andheri cab with professional chauffeurs, fixed fares, comfortable AC vehicles, and convenient pickup for business and airport travel."
  },
  {
    "name": "Pune to Mumbai Cab Round Trip",
    "description": "Pune to Mumbai cab round trip packages offer flexible return schedules for business visits, sightseeing, family vacations, and corporate travel with affordable pricing."
  },
  {
    "name": "Ertiga on Rent in Pimple Saudagar",
    "description": "Book Ertiga on rent in Pimple Saudagar for family trips, airport transfers, outstation travel, and business transportation with spacious seating and professional drivers."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune provides local taxi, airport transfer, corporate travel, and outstation transportation with Sedan, Ertiga, Innova Crysta, SUVs, and premium vehicles."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Reliable Pune Mumbai cab service for one-way, airport, business, sightseeing, and round-trip travel with transparent pricing and experienced chauffeurs."
  },
  {
    "name": "Cab Service Pimple Saudagar Pune",
    "description": "Professional cab service in Pimple Saudagar Pune for local travel, airport transfers, employee transportation, outstation trips, and business travel with clean AC vehicles."
  },
  {
    "name": "Pimple Saudagar to Mumbai Cabs",
    "description": "Book Pimple Saudagar to Mumbai cabs for affordable and comfortable intercity travel with multiple vehicle options including Sedan, Ertiga, Innova Crysta, SUVs, and luxury cars."
  },
  {
    "name": "Pimple Saudagar to Mumbai Taxi",
    "description": "Reliable Pimple Saudagar to Mumbai taxi service with fixed pricing, professional drivers, and well-maintained vehicles for airport, business, and leisure travel."
  },
  {
    "name": "Pimple Saudagar to Mumbai Cab Service",
    "description": "Choose Pimple Saudagar to Mumbai cab service for one-way journeys, airport transfers, corporate travel, sightseeing, and round trips with transparent pricing."
  },
  {
    "name": "Pimple Saudagar to Mumbai Taxi Service",
    "description": "Our Pimple Saudagar to Mumbai taxi service offers safe, comfortable, and dependable travel with experienced chauffeurs and multiple vehicle categories."
  },
  {
    "name": "Pimple Saudagar to Mumbai Cab Booking",
    "description": "Book Pimple Saudagar to Mumbai cab instantly with online confirmation, flexible pickup timing, fixed pricing, and reliable customer support available 24x7."
  },
  {
    "name": "Cab from Pimple Saudagar to Mumbai",
    "description": "Reserve a cab from Pimple Saudagar to Mumbai for airport transfers, corporate travel, business meetings, sightseeing, and family trips with professional drivers."
  },
  {
    "name": "Pimple Saudagar to Mumbai Car Rental",
    "description": "Pimple Saudagar to Mumbai car rental offers one-way, airport transfer, business travel, and round-trip packages with Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles."
  },
  {
    "name": "Pimple Saudagar to Mumbai One Way Cab",
    "description": "Book Pimple Saudagar to Mumbai one way cab and pay only for your single trip. Ideal for airport transfers, business visits, and personal travel with fixed transparent fares."
  },
  {
    "name": "Cheap Pimple Saudagar to Mumbai Cab",
    "description": "Affordable Pimple Saudagar to Mumbai cab service with comfortable AC vehicles, experienced chauffeurs, fixed pricing, and reliable transportation without hidden charges."
  },
  {
    "name": "Pimple Saudagar to Mumbai Taxi Fare",
    "description": "Check Pimple Saudagar to Mumbai taxi fare with transparent pricing for Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles suitable for every travel budget."
  },
  {
    "name": "Book Pimple Saudagar to Mumbai Cab Online",
    "description": "Book Pimple Saudagar to Mumbai cab online with instant confirmation, secure reservations, multiple vehicle choices, and professional chauffeur service."
  },
  {
    "name": "Pimple Saudagar to Mumbai Outstation Cab",
    "description": "Reliable Pimple Saudagar to Mumbai outstation cab service for long-distance travel with experienced drivers, comfortable vehicles, and flexible pickup schedules."
  },
  {
    "name": "Pimple Saudagar to Mumbai Airport Cab",
    "description": "Reserve Pimple Saudagar to Mumbai Airport cab with direct transfers to all airport terminals, luggage assistance, flight tracking, and timely pickup."
  },
  {
    "name": "24x7 Pimple Saudagar to Mumbai Taxi Service",
    "description": "Our 24x7 Pimple Saudagar to Mumbai taxi service is available round the clock for airport transfers, emergency travel, business meetings, and family trips."
  },
  {
    "name": "Best Pimple Saudagar to Mumbai Cab Service",
    "description": "Experience the best Pimple Saudagar to Mumbai cab service with premium vehicles, professional chauffeurs, transparent pricing, instant booking, and outstanding customer support."
  }
],

"tableData": [
  ["Pimple Saudagar to Mumbai Cab", "Pimple Saudagar to Mumbai Airport Cab"],
  ["Pimple Saudagar to Mumbai International Airport", "Pimple Gurav to Mumbai Cab Service"],
  ["Taxi Service in Pimple Gurav", "Taxi Service in Pimple Saudagar Pune"],
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
  ["Pune to Mumbai Innova Cab", "Top-rated Mumbai to Pimple Saudagar Cabs"],
  ["Pimple Saudagar to Dadar Cab Service", "Pimple Gurav to Dadar Cab Service"],
  ["Cab Service in Pimple Gurav", "Innova Crysta on Rent in Pimple Saudagar Pune"],
  ["Pimple Saudagar to Andheri Cab", "Pune to Mumbai Cab Round Trip"],
  ["Ertiga on Rent in Pimple Saudagar", "Cab Service in Pune"],
  ["Pune Mumbai Cab", "Cab Service Pimple Saudagar Pune"],
  ["Pimple Saudagar to Mumbai Cabs", "Pimple Saudagar to Mumbai Taxi"],
  ["Pimple Saudagar to Mumbai Cab Service", "Pimple Saudagar to Mumbai Taxi Service"],
  ["Pimple Saudagar to Mumbai Cab Booking", "Cab from Pimple Saudagar to Mumbai"],
  ["Pimple Saudagar to Mumbai Car Rental", "Pimple Saudagar to Mumbai One Way Cab"],
  ["Cheap Pimple Saudagar to Mumbai Cab", "Pimple Saudagar to Mumbai Taxi Fare"],
  ["Book Pimple Saudagar to Mumbai Cab Online", "Pimple Saudagar to Mumbai Outstation Cab"],
  ["Pimple Saudagar to Mumbai Airport Cab", "24x7 Pimple Saudagar to Mumbai Taxi Service"],
  ["Best Pimple Saudagar to Mumbai Cab Service", ""]
],






whychoose: [
  {
    WhyChooseheading: "Reliable Pimple Saudagar to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable cab services from Pimple Saudagar to Mumbai with comfortable vehicles and professional chauffeurs."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Pimple Saudagar",
    WhyChoosedescription: "Enjoy convenient pickup from Pimple Saudagar, Rahatani, Wakad, Aundh, Pimple Nilakh, and nearby residential areas."
  },
  {
    WhyChooseheading: "Safe & Comfortable Highway Travel",
    WhyChoosedescription: "Our experienced drivers ensure a smooth, secure, and relaxing journey via the Mumbai-Pune Expressway."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Trustline Travels offers fair and upfront pricing with no hidden charges, giving you complete peace of mind."
  },
  {
    WhyChooseheading: "Well-Maintained Vehicle Fleet",
    WhyChoosedescription: "Travel in clean, air-conditioned Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers maintained to high standards."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cabs, round-trip bookings, or customized travel packages that fit your itinerary."
  },
  {
    WhyChooseheading: "Perfect for Airport & Corporate Travel",
    WhyChoosedescription: "Our cab service is ideal for Mumbai Airport transfers, business meetings, family visits, and leisure travel."
  },
  {
    WhyChooseheading: "Instant Booking Assistance",
    WhyChoosedescription: "Receive quick fare quotations and immediate booking confirmation with the support of our dedicated customer service team."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pimple Saudagar to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers reliable cab services from Pimple Saudagar to Mumbai for one-way, round-trip, airport, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Pimple Saudagar to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with flexible pickup timings and comfortable travel."
  },
  {
    question: "Which vehicles are available for this route?",
    answer: "You can choose from Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel requirements."
  },
  {
    question: "Do you provide pickup from nearby areas of Pimple Saudagar?",
    answer: "Yes, we provide doorstep pickup from Pimple Saudagar, Rahatani, Pimple Nilakh, Wakad, Aundh, and surrounding locations."
  },
  {
    question: "Can I book a cab to Mumbai Airport?",
    answer: "Yes, we provide direct cab services from Pimple Saudagar to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specified in the booking quotation."
  },
  {
    question: "Is your cab service available 24/7?",
    answer: "Yes, Trustline Travels operates round the clock for early morning, daytime, and late-night travel."
  },
  {
    question: "Can I reserve my cab before my travel date?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup schedule."
  },
  {
    question: "Do you provide cabs for business travel to Mumbai?",
    answer: "Yes, our cab service is widely used by corporate professionals traveling from Pimple Saudagar to Mumbai."
  },
  {
    question: "How can I book a Pimple Saudagar to Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, and preferred vehicle to receive an instant fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Jadhav",
    feedback: "Trustline Travels arranged a prompt pickup from Pimple Saudagar for my Mumbai office visit. The cab was clean, the driver was courteous, and the entire trip was completed comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neeta Kulkarni",
    feedback: "We booked an Innova for our family's journey from Pimple Saudagar to Mumbai, and the experience was outstanding. The vehicle was spacious, the ride was smooth, and the service was highly professional.",
    rating: 5
  }
];













  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimple Saudagar to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pimple-saudagar-to-mumbai-cab.webp",
  "description": "Book Pimple Saudagar to Mumbai cab service for safe, comfortable, and affordable travel. Trustline Travels offers one-way, round-trip, and Mumbai Airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pimple-saudagar-to-mumbai-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Pimple Saudagar to Mumbai Cab | Airport Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pimple Saudagar to Mumbai cab service with Trustline Travels for reliable one-way, round-trip, and airport transfers. Enjoy affordable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxi services with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Pimple Saudagar to Mumbai Cab, pimple saudagar to mumbai airport cab, pimple saudagar to mumbai international airport, pimple gurav to mumbai cab service, taxi service in pimple gurav, taxi service in pimple saudagar pune, pune to mumbai airport cab, pimple saudagar to mumbai taxi, pimple saudagar to mumbai one way cab, pimple saudagar to mumbai innova cab, pimple saudagar to mumbai ertiga cab, pimple gurav taxi service, mumbai airport cab from pimple saudagar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/39.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimplesaudagartomumbaicabservice;